<template>
  <nav id="nav" class="nav" ref="navigation">
    <div v-for="d1 in nav" class="nav-menu" :key="d1.sequence" @mouseenter="handleHover" @mouseleave="handleHover">
      <input
        type="radio"
        :id="`d1-${d1.sequence}`"
        class="nav-menu__trigger a11y"
        name="nav-menu__trigger"
        :value="`d1-${d1.sequence}`"
        @click="handleActiveNav"
      />
      <label :for="`d1-${d1.sequence}`" class="nav-menu__label">
        <span class="a11y">{{ d1.title }} 메뉴 열기</span>
        <icon-arrow class="icon icon-arrow--down" />
      </label>

      <a
        :href="getUrlPath(d1.titleLink)"
        class="nav-menu__d1"
        :class="{ 'is-current--menu': handleCurrentMenu(getUrlPath(d1.titleLink)) }"
        :target="d1.target"
      >
        {{ d1.title }}
      </a>

      <div class="nav-menu__block">
        <a
          :href="getUrlPath(d1.subtitleLink)"
          class="nav-menu__more"
          :role="d1.subtitleLink ? 'heading link' : 'heading'"
        >
          <mark>{{ d1.subtitle | extractSubtitle(0) }}</mark>
          <pre>{{ d1.subtitle | extractSubtitle(1) }}</pre>
          <!-- <icon-arrow class="icon icon-arrow- -right" /> -->
        </a>
        <ul class="nav-menu__list">
          <li v-for="(d2, i) in d1.children" :key="i">
            <a
              :href="getUrlPath(d2.titleLink)"
              ref="menuD2"
              class="nav-menu__d2"
              :class="{
                'is-current--menu': handleCurrentMenu(getUrlPath(d2.titleLink)),
              }"
              :target="d2.target"
            >
              {{ d2.title }}
            </a>
          </li>
        </ul>

        <a
          v-if="d1.banner"
          :href="d1.banner.targetUrl"
          class="nav-banner"
          :class="`nav-banner--${d1.sequence}`"
          :target="d1.banner.targetWindow && '_blank'"
        >
          <strong class="nav-banner__strong">
            <span class="label">{{ d1.banner.subtitle }}</span>
            <span class="nav-banner__title" :style="{ color: d1.banner.assets.DESKTOP[0].bgTheme }">
              {{ d1.banner.title }}
            </span>
          </strong>

          <picture class="nav-banner__pic">
            <source
              media="(max-width: 959px)"
              :srcset="d1.banner.assets.DESKTOP[0].url || d1.banner.assets.MOBILE[0].url"
            />
            <source media="(min-width: 960px)" :srcset="d1.banner.assets.DESKTOP[0].url" />
            <img :src="d1.banner.assets.DESKTOP[0].url" alt="" />
          </picture>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import IconArrow from './icons/arrow.svg';

import { debounce } from '../mixins';

export default {
  props: ['nav', 'is-active-nav'],
  mixins: [debounce],
  components: {
    IconArrow,
  },
  methods: {
    handleActiveNav(e) {
      const activeMenu = this.activeMenu === e.target.value;
      if (activeMenu) e.target.checked = false;
      this.activeMenu = activeMenu ? null : e.target.value;
    },
    handleHover(e) {
      this.debounce(() => {
        this.isActiveNavigation = e.type === 'mouseenter';
        this.resetActiveMenus();
        this.isActiveNavigation && e.target.classList.add('is-current--menu');
        this.$emit('emit-header', this.isActiveNavigation);
      }, 10);
    },
    handleCurrentMenu(path) {
      return path === this.$route.path;
    },
    getUrlPath(path) {
      if (!path) {
        return null;
      } else if (path.slice(-1) === '/') {
        return path.slice(0, -1);
      } else {
        return path;
      }
    },
    getBlankLink(path) {
      const reg = /^((http(s?))\:\/\/)/;

      if (reg.exec(path)) {
        return path.includes(window.location.origin) || '_blank';
      }
    },
    resetActiveMenus() {
      const menus = document.querySelectorAll('.nav-menu');
      menus.forEach((menu) => {
        menu.classList.remove('is-current--menu');
      });
    },
  },
  mounted() {
    const activeMenu = this.$refs.navigation.querySelectorAll('.is-current--menu');
    activeMenu.forEach((item) =>
      item.closest('.nav-menu').querySelector('.nav-menu__d1').classList.add('is-current--menu')
    );
  },
  data() {
    return {
      isActiveNavigation: this.isActiveNav,
      isActiveMenu: false,
      activeMenu: null,
    };
  },
  filters: {
    extractSubtitle(string, index) {
      const lines = (string || '').split(/\n(.*)/s);
      // [index - 1] <- use [0] as [1] if there's no [1]
      return lines[index] || lines[index - 1] || '';
    },
  },
};
</script>
